{
  "status": {
    "thinking": "Nolë réfléchit…",
    "waitingForResponse": "En attente de réponse…",
    "responseFailed": "La réponse a échoué.",
    "writing": "Nolë écrit",
    "errorOccurred": "Une erreur est survenue."
  },
  "generationError": {
    "rateLimited": "Le modèle est temporairement saturé chez son fournisseur. Réessaie dans un instant, ou choisis un autre modèle.",
    "unavailable": "Le fournisseur du modèle est momentanément indisponible. Réessaie dans un instant, ou choisis un autre modèle.",
    "credits": "Le service IA est momentanément indisponible. Réessaie plus tard, ou choisis un autre modèle.",
    "contextTooLong": "Cette conversation est trop longue pour ce modèle. Ouvre une nouvelle session, ou choisis un modèle au contexte plus large.",
    "unsupported": "Ce modèle ne sait pas traiter cette demande. Choisis un autre modèle.",
    "interrupted": "La réponse a été interrompue avant la fin. Réessaie."
  },
  "branch": {
    "yourSession": "votre session",
    "mergedInto": "Fusionnée dans « {{title}} »",
    "branchOf": "Branche de « {{title}} »"
  },
  "panel": {
    "untitledChat": "Conversation sans titre",
    "newChat": "Nouvelle conversation",
    "newSession": "Nouvelle session",
    "closePanel": "Fermer le panneau"
  },
  "suggestions": {
    "hello": "Bonjour {{name}}",
    "startTalking": "Commencez à parler à Nolë",
    "intro": "Voici quelques idées pour commencer.",
    "research": {
      "label": "Explorer un sujet",
      "prompt": "Fais une recherche sur le web à propos du sujet ci-dessous. Crée ensuite sur ce canvas un node BlockNote contenant un résumé concis et les liens vers les sources. Sujet : [sujet]"
    },
    "image": {
      "label": "Créer une image",
      "prompt": "Crée un node image sur ce canvas et remplis son prompt de génération d'image à partir de cette idée : [décrivez l'image, ou laissez vide pour qu'elle invente]"
    },
    "projectTracker": {
      "label": "Créer un suivi de projet",
      "prompt": "Crée un node tableau intitulé « Suivi de projet » avec les colonnes Tâche (texte), Échéance (date) et Statut (sélection : Pas commencé, En cours, Terminé). Ajoute trois lignes d'exemple clairement identifiées. Crée ensuite un AppNode connecté au tableau qui affiche le nombre de tâches par statut sous forme de camembert."
    },
    "pomodoro": {
      "label": "Créer un minuteur Pomodoro",
      "prompt": "Crée un AppNode de minuteur Pomodoro avec une session de concentration de 25 minutes, une pause de 5 minutes, un compte à rebours et des boutons Démarrer, Pause et Réinitialiser. Les temps sont enregistrés côté serveur pour survivre aux rechargements."
    },
    "franceImages": {
      "label": "Montre-moi des images de la France",
      "prompt": "Crée cinq nodes image, un pour chacun de ces lieux : la Bretagne, Paris, Marseille, Annecy et Bordeaux. Trouve les images sur le web."
    },
    "onboarding": {
      "label": "Prototyper un parcours d'onboarding",
      "prompt": "Crée un node BlockNote décrivant un parcours d'onboarding en 3 étapes pour Nolënor. Crée ensuite un AppNode qui prototype ce parcours avec des boutons Retour, Suivant et Terminer, et connecte-le au node de spécification."
    }
  },
  "mention": {
    "notFoundTitle": "Node introuvable ({{nodeId}}) : supprimé ou absent de ce canvas",
    "titleNotFound": "{{title}} · introuvable",
    "notFound": "Node introuvable",
    "node": "Node",
    "clickHint": "{{title}} — cliquez pour y aller, {{modifier}}+clic pour l'ouvrir",
    "clickToOpen": "{{title}} — cliquez pour l'ouvrir"
  },
  "composer": {
    "answerPlaceholder": "Tapez votre réponse à la question de Nolë…",
    "dictateHint": "Maintenez Alt + Ctrl pour dicter · cliquez pour choisir le moteur de dictée",
    "placeholder": "Demandez à Nolë, @ pour mentionner un node",
    "mentionListLabel": "Nodes du canvas à mentionner",
    "model": "Modèle",
    "stop": "Arrêter",
    "send": "Envoyer le message",
    "sendQueued": "Envoyer — ajouté après l'étape en cours",
    "sendQueuedHint": "Ajouté à la réponse en cours, après l'étape en cours"
  },
  "threads": {
    "history": "Historique des conversations",
    "empty": "Aucune conversation sur ce canvas",
    "delete": "Supprimer la conversation",
    "deleteError": "Impossible de supprimer la conversation."
  },
  "stats": {
    "contextUsed": "Contexte utilisé : {{percent}}",
    "threadUsage": "Consommation de la conversation",
    "consumed": "Consommé",
    "tokens": "{{tokens}} tk",
    "currentContext": "Contexte actuel : {{tokens}} tk",
    "cost": "Coût : {{cost}}"
  },
  "chat": {
    "loadMore": "Charger plus de messages",
    "startConversation": "Commencez une conversation…",
    "errorBoundary": {
      "title": "Impossible d'afficher la conversation",
      "message": "Les messages n'ont pas pu être chargés. Vous pouvez réessayer ou recharger la page — votre travail est enregistré sur le serveur.",
      "retry": "Réessayer"
    }
  },
  "attachments": {
    "emptyHint": "<kbd>Alt + clic</kbd><rest>pour joindre un node, un bloc ou une cellule</rest>",
    "remove": "Retirer la pièce jointe",
    "removePosition": "Retirer la position",
    "position": "Position ({{x}}, {{y}})",
    "attachNode": "Joindre le node"
  },
  "mic": {
    "starting": "Ouverture du micro…",
    "listening": "Écoute…",
    "transcribing": "Transcription…"
  },
  "voiceProvider": {
    "title": "Moteur de dictée",
    "mistralHint": "Voxtral 3 Mini · langue auto",
    "gladiaHint": "Vocabulaire personnalisé · fr/en"
  },
  "quotes": {
    "tooMany_one": "{{count}} commentaire maximum par message : envoyez-le d'abord.",
    "tooMany_other": "{{count}} commentaires maximum par message : envoyez-les d'abord.",
    "noleReply": "Réponse de Nolë",
    "document": "Document",
    "comment": "Commenter",
    "showPassage": "Afficher le passage",
    "editComment": "Modifier le commentaire",
    "removeComment": "Retirer ce commentaire",
    "addComment": "+ Ajouter un commentaire",
    "addToChat": "Ajouter au chat",
    "addToChatHint": "Ajouter au chat (Entrée)",
    "formFooter": "Ajouté au chat de Nolë, envoyé avec votre prochain message",
    "commentPlaceholder": "Commentez ou demandez à Nolë…",
    "replyFurtherUp": "Cette réponse est plus haut : chargez plus de messages pour la voir."
  },
  "dividers": {
    "compaction": {
      "text": "Début de la conversation résumé",
      "title": "Nolë travaille désormais à partir d'un résumé des messages ci-dessus"
    },
    "previousSession": {
      "text": "Reprend votre session précédente",
      "title": "Nolë part d'un résumé de vos sessions précédentes sur ce canvas"
    },
    "fork": {
      "text": "Fusionné depuis une branche parallèle",
      "title": "Cette demande a tourné en parallèle, puis a rejoint la conversation"
    }
  },
  "subagent": {
    "done": "Tâche d'arrière-plan terminée",
    "error": "Échec de la tâche d'arrière-plan",
    "aborted": "Tâche d'arrière-plan arrêtée"
  },
  "queued": {
    "withdrawError": "Impossible de retirer le message",
    "commentedPassages_one": "{{count}} passage commenté",
    "commentedPassages_other": "{{count}} passages commentés",
    "remove": "Retirer ce message",
    "label": "En attente — ajouté après l'étape en cours"
  },
  "tools": {
    "viewImage": "Voir l'image",
    "listCanvases": "Lister les canvas",
    "exploreCanvas": "Explorer le canvas",
    "useComputer": "Utiliser son ordinateur",
    "askNetworkAccess": "Demander à visiter des sites",
    "toolFeedback": "Note pour les développeurs",
    "webSearch": "Recherche web",
    "openWebPage": "Ouvrir une page web",
    "createNode": "Créer un node",
    "updateNode": "Mettre à jour le node",
    "insertBlocks": "Insérer des blocs",
    "replaceBlock": "Remplacer un bloc",
    "deleteBlocks": "Supprimer des blocs",
    "editBlockText": "Modifier le texte d'un bloc",
    "updateBlock": "Mettre à jour un bloc",
    "insertRows": "Insérer des lignes",
    "updateRows": "Mettre à jour des lignes",
    "deleteRows": "Supprimer des lignes",
    "updateTableSchema": "Modifier les colonnes du tableau",
    "setTableView": "Trier / filtrer le tableau",
    "groupNodes": "Grouper des nodes",
    "moveNodes": "Déplacer / restyler des nodes",
    "deleteElements": "Supprimer",
    "editAppCode": "Modifier le code de l'app",
    "editTranscript": "Modifier la transcription",
    "connectNodes": "Connecter des nodes",
    "updateMemory": "Mettre à jour les souvenirs",
    "loadSkill": "Charger un skill",
    "runSubAgent": "Lancer un sous-agent"
  },
  "activity": {
    "denied": "Refusé.",
    "toolFailed": "L'outil a signalé un échec.",
    "readNodes_one": "{{count}} node lu",
    "readNodes_other": "{{count}} nodes lus",
    "exploredCanvas": "canvas exploré",
    "canvasSearches_one": "recherche dans le canvas",
    "canvasSearches_other": "{{count}} recherches dans le canvas",
    "webSearches_one": "recherche sur le web",
    "webSearches_other": "{{count}} recherches sur le web",
    "openedPages_one": "{{count}} page ouverte",
    "openedPages_other": "{{count}} pages ouvertes",
    "createdNodes_one": "{{count}} node créé",
    "createdNodes_other": "{{count}} nodes créés",
    "editedNodes_one": "{{count}} node modifié",
    "editedNodes_other": "{{count}} nodes modifiés",
    "madeEdits_one": "{{count}} modification",
    "madeEdits_other": "{{count}} modifications",
    "addedConnections_one": "{{count}} connexion ajoutée",
    "addedConnections_other": "{{count}} connexions ajoutées",
    "deletedNodes_one": "{{count}} node supprimé",
    "deletedNodes_other": "{{count}} nodes supprimés",
    "deletedConnections_one": "{{count}} connexion supprimée",
    "deletedConnections_other": "{{count}} connexions supprimées",
    "updatedMemory": "souvenirs mis à jour",
    "loadedSkills_one": "skill chargé",
    "loadedSkills_other": "{{count}} skills chargés",
    "ranSubAgents_one": "sous-agent lancé",
    "ranSubAgents_other": "{{count}} sous-agents lancés",
    "usedTools_one": "{{count}} outil utilisé",
    "usedTools_other": "{{count}} outils utilisés",
    "triedActions_one": "{{count}} action tentée",
    "triedActions_other": "{{count}} actions tentées",
    "thought": "réflexion",
    "thinking": "Réflexion…",
    "thoughtStep": "Réflexion",
    "steps_one": "{{count}} étape",
    "steps_other": "{{count}} étapes",
    "failedCount_one": "{{count}} échec",
    "failedCount_other": "{{count}} échecs",
    "stopped": "arrêté",
    "more_one": "+{{count}} autre",
    "more_other": "+{{count}} autres",
    "input": "Entrée",
    "output": "Sortie",
    "truncated": "… (tronqué — copiez pour tout récupérer)"
  },
  "question": {
    "sendError": "Impossible d'envoyer votre réponse",
    "skipped": "Ignorée",
    "notAnswered": "Sans réponse.",
    "selectAll": "Sélectionnez toutes les réponses qui conviennent.",
    "somethingElse": "Autre chose",
    "yourAnswer": "Votre réponse",
    "missingAnswer": "La question {{number}} n'a pas encore de réponse.",
    "orReplyBelow": "Ou répondez dans le champ du chat ci-dessous.",
    "skip": "Passer",
    "submit": "Envoyer",
    "next": "Suivant",
    "previousQuestion": "Question précédente",
    "nextQuestion": "Question suivante",
    "pager": "{{page}} sur {{total}}"
  },
  "tasks": {
    "stopped": "Arrêtée avant la fin.",
    "failed": "Une erreur est survenue.",
    "parallelTo": "En parallèle de « {{title}} »",
    "parallelToSession": "En parallèle de votre session",
    "partial": "Des modifications ont été faites avant l'arrêt.",
    "retryError": "Impossible de relancer la tâche",
    "fullAnswer": "Réponse complète dans la conversation",
    "background_one": "{{count}} tâche en arrière-plan",
    "background_other": "{{count}} tâches en arrière-plan",
    "inContext": "Dans « {{title}} »",
    "dismiss": "Masquer"
  },
  "markdown": {
    "copyCode": "Copier le code"
  },
  "voiceMemo": {
    "discardTitle": "Supprimer ce mémo vocal ?",
    "discardText": "L'enregistrement sera perdu.",
    "discard": "Supprimer",
    "record": "Enregistrer un mémo vocal",
    "recordingShow": "Enregistrement en cours — cliquez pour l'afficher",
    "recordShortcut": "Enregistrer un mémo vocal (R)",
    "recording": "Enregistrement",
    "failed": "Échec du mémo vocal",
    "waitingMic": "En attente du micro…",
    "savingPercent": "Enregistrement… {{percent}} %",
    "hint": "Devient un node audio sur ce canvas",
    "hide": "Masquer — l'enregistrement continue",
    "stopAndSave": "Arrêter et enregistrer",
    "savedElsewhere": "Mémo vocal ajouté au canvas où vous l'avez enregistré"
  }
}
